/**
 * Format view count like YouTube: K (thousands), M (millions), B (billions).
 * e.g. 1_000_000_000 → "1B", 50_000_000 → "50M", 1_234 → "1.2K"
 */
export function formatViewCount(views: number): string {
  if (typeof views !== 'number' || !Number.isFinite(views) || views < 0) {
    return '0'
  }
  if (views >= 1e9) {
    const b = views / 1e9
    return b >= 10 || b % 1 === 0 ? `${Math.floor(b)}B` : `${b.toFixed(1)}B`
  }
  if (views >= 1e6) {
    const m = views / 1e6
    return m >= 10 || m % 1 === 0 ? `${Math.floor(m)}M` : `${m.toFixed(1)}M`
  }
  if (views >= 1e3) {
    const k = views / 1e3
    return k >= 10 || k % 1 === 0 ? `${Math.floor(k)}K` : `${k.toFixed(1)}K`
  }
  return String(Math.floor(views))
}
